import React from 'react'

const LogoutIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path d="M10.5 0.75C10.5 0.335786 10.1642 0 9.75 0C9.33579 0 9 0.335786 9 0.75V4.75C9 5.16421 9.33579 5.5 9.75 5.5C10.1642 5.5 10.5 5.16421 10.5 4.75V0.75Z" fill="#171717" />
            <path d="M6.5419 3.14678C6.92345 2.98557 7.10208 2.54557 6.94087 2.16402C6.77966 1.78246 6.33966 1.60384 5.9581 1.76505C2.45832 3.24372 0 6.70891 0 10.75C0 16.1348 4.36522 20.5 9.75 20.5C15.1348 20.5 19.5 16.1348 19.5 10.75C19.5 6.70891 17.0417 3.24372 13.5419 1.76505C13.1603 1.60384 12.7203 1.78246 12.5591 2.16402C12.3979 2.54557 12.5765 2.98557 12.9581 3.14678C15.9222 4.39913 18 7.33279 18 10.75C18 15.3064 14.3063 19 9.75 19C5.19365 19 1.5 15.3064 1.5 10.75C1.5 7.33279 3.57779 4.39913 6.5419 3.14678Z" fill="#171717" />
        </svg>
    )
}

export default LogoutIcon